import {
  Breadcrumbs,
  BrowserClient,
  Dedupe,
  defaultStackParser,
  getCurrentHub,
  GlobalHandlers,
  HttpContext,
  makeFetchTransport
} from "@sentry/react"

import { env } from "./env"
import { getRepositoryName } from "./routing"

export const createSentryClient = () => {
  const client = new BrowserClient({
    environment: env.PAGE_BUILDER_SENTRY_ENVIRONMENT,
    dsn: env.PAGE_BUILDER_SENTRY_DSN,
    tracesSampleRate: 0.01,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [
      new Breadcrumbs(),
      new GlobalHandlers(),
      new Dedupe(),
      new HttpContext()
    ],
    beforeSend(event) {
      event.tags ||= {}
      event.tags["repository"] = getRepositoryName()
      event.tags["commit"] = env.PRISMIC_GIT_COMMIT_HASH
      return event
    }
  })

  getCurrentHub().bindClient(client)
}
